import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  addTransaction,
  getAllTransactions,
  editTransaction,
  deleteTransaction,
} from "./TransactionAPI";

const initialState = {
  transactions: [],
  allTransactions: [],
  noOfTotalRecords: 0,
  loading: false,
  error: null,
  isError: false,
  balance: 0,
};
//thunk function for retrieving  transactions
export const fetchTransactions = createAsyncThunk(
  "transaction/fetchTransactions",
  async ({
    searchTerm,
    transactionType,
    order,
    limit,
    start,
    balanceRequired,
  }) => {
    const trasactions = await getAllTransactions(
      searchTerm,
      transactionType,
      order,
      limit,
      start,
      balanceRequired
    );
    return trasactions;
  }
);

//thuk function for creating a transaction
export const createTransaction = createAsyncThunk(
  "transaction/createTransction",
  async (data) => {
    const trasaction = await addTransaction(data);
    return trasaction;
  }
);

//thunk function for edeting a transaction
export const updateTransaction = createAsyncThunk(
  "transaction/updateTransaction",
  async ({ data, id }) => {
    const trasaction = await editTransaction(data, id);

    return trasaction;
  }
);
//thunk function delete a transaction
export const removeTransaction = createAsyncThunk(
  "transaction/removeTransaction",
  async (id) => {
    const trasaction = await deleteTransaction(id);
    return trasaction;
  }
);

const transctionSlice = createSlice({
  name: "transaction",
  initialState,
  extraReducers: (builder) => {
    builder
      .addCase(fetchTransactions.fulfilled, (state, action) => {
        state.loading = false;
        state.isError = false;
        state.error = null;
        state.transactions = action.payload.data;
        state.noOfTotalRecords = action.payload.noOfTotalRecords;
        state.balance = action.payload.balance;
      })
      .addCase(fetchTransactions.rejected, (state, action) => {
        state.loading = false;
        state.isError = true;
        state.error = action.error?.message;
        state.transactions = [];
      })
      .addCase(fetchTransactions.pending, (state, action) => {
        state.loading = true;
        state.isError = false;
        state.error = null;
      })

      .addCase(createTransaction.fulfilled, (state, action) => {
        state.loading = false;
        state.isError = false;
        state.error = null;
        state.transactions.push(action.payload);
      })
      .addCase(createTransaction.rejected, (state, action) => {
        state.loading = false;
        state.isError = true;
        state.error = action.error?.message;
      })
      .addCase(createTransaction.pending, (state, action) => {
        state.loading = true;
        state.isError = false;
        state.error = null;
      })
      .addCase(updateTransaction.fulfilled, (state, action) => {
        state.loading = false;
        state.isError = false;
        state.error = null;
        let index = state.transactions.findIndex(
          (t) => t.id === action.payload.id
        );
        state.transactions[index] = action.payload;
      })
      .addCase(updateTransaction.rejected, (state, action) => {
        state.loading = false;
        state.isError = true;
        state.error = action.error?.message;
      })
      .addCase(updateTransaction.pending, (state, action) => {
        state.loading = true;
        state.isError = false;
        state.error = null;
      })
      .addCase(removeTransaction.fulfilled, (state, action) => {
        console.log(action);
        state.loading = false;
        state.isError = false;
        state.error = null;
        state.transactions = state.transactions.filter(
          (t) => t.id !== action.meta.arg
        );
        state.noOfTotalRecords = state.noOfTotalRecords - 1;
      })
      .addCase(removeTransaction.rejected, (state, action) => {
        state.loading = false;
        state.isError = true;
        state.error = action.error?.message;
      })
      .addCase(removeTransaction.pending, (state, action) => {
        state.loading = true;
        state.isError = false;
        state.error = null;
      });
  },
});

export const transactionReducer = transctionSlice.reducer;
